export default {
  methods: {
    scrollToElem (parent, elem, duration) {
      if (!elem) return
      const sidebar = 279
      const offset = Math.round(elem.getBoundingClientRect().left - 50 - sidebar)
      const x = parent.scrollLeft + offset
      this.scrollToX(x, duration, parent)
    },
    scrollToX (x, duration = 0, element) {
      if (element.scrollLeft === x) return
      const cosParameter = (element.scrollLeft - x) / 2
      let scrollCount = 0
      let oldTimestamp = null

      function step (newTimestamp) {
        if (oldTimestamp !== null) {
          scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration
          if (scrollCount >= Math.PI) {
            element.scrollLeft = x
            return
          }
          element.scrollLeft = cosParameter + x + cosParameter * Math.cos(scrollCount)
        }
        oldTimestamp = newTimestamp
        window.requestAnimationFrame(step)
      }
      window.requestAnimationFrame(step)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/scrollToElem.js